import React, { useState, useEffect } from 'react';

import AuthorAvatar from '../components/AuthorAvatar';

// initial images
import ImgJudy from '../images/villagers/Judy.png';
import ImgMolly from '../images/villagers/Molly.png';

//let topfourtyname = this.topVillagers.map(v => v.name)
//let topnameArray = ['Judy', 'Audie', 'Stitches', 'Raymond', 'Poppy', 'Molly', 'Dom', 'Maple', 'Coco', 'Beau', 'Lucky', 'Roald', 'Sherb', 'Ankha', 'Bob', 'Julian', 'Apollo', 'Merry', 'Kabuki', 'Dobie', 'Pekoe', 'Tangy', 'Whitney', 'Cookie', 'Marshal', 'Genji', 'Reneigh', 'Diana', 'Fauna', 'Ketchup', 'Sylvana', 'Erik', 'Fang', 'Lolly', 'Filbert', 'Bluebear', 'Daisy', 'Kiki', 'Marina', 'Zucker']
const topnameTopArray = ['Judy', 'Audie', 'Stitches', 'Raymond', 'Poppy', 'Molly', 'Dom', 'Maple', 'Coco', 'Beau', 'Lucky', 'Roald', 'Sherb', 'Ankha', 'Bob', 'Julian', 'Apollo']
const topnameArray1 = ['Judy', 'Audie', 'Stitches', 'Raymond', 'Poppy', 'Molly', 'Dom', 'Maple', 'Coco']
const topnameArray2 =['Beau', 'Lucky', 'Roald', 'Sherb', 'Ankha', 'Bob', 'Julian', 'Apollo']

const Header = () => {
  //const [seconds, setSeconds] = useState(0);
  const [currentFirstImage, setCurrentFirstImage] = useState(ImgMolly);
  const [currentSecondImage, setCurrentSecondImage] = useState(ImgJudy);

  let cloudtypeObj = {3:'three', 2: 'two', 1:'one'};
  let cloudPathObj = {
    3:'M40.5502 57.572C65.0812 82.6037 88.611 66.0828 98.6236 59.3892C100.126 58.0726 100.928 58.7306 102.128 59.3892C114.142 65.9842 141.934 61.5771 140.676 37.046C139.803 20.0245 128.661 11.0131 114.142 11.0131C101.626 11.0131 98.6804 16.2251 95.1189 12.515C71.089 -12.5168 45.3342 9.51107 42.5529 14.5175C41.4404 16.52 38.9536 18.5225 36.5453 17.5213C-8.01104 -1.00211 -12.517 65.0815 31.5386 58.0726C36.5451 57.2762 38.047 55.0178 40.5502 57.572Z',
    2:'M23.9772 42.4603C-6.49362 43.9588 -9.49117 0.500566 25.4755 1.00006C39.9619 1.99904 42.4595 12.489 47.4547 12.489C53.9485 12.489 53.3883 2.49855 71.9313 2.49855C104.9 2.99808 98.4059 45.9569 70.9322 43.9588C57.9447 43.0143 51.9503 32.4698 47.4547 32.4698C42.959 32.4698 40.4614 42.4603 23.9772 42.4603Z',
    1:'M40.5 15.1835C40.5 23.0134 32.9513 30.3734 21.7658 30.3734C10.5803 30.3734 0.5 24.026 0.5 16.1962C0.5 8.36631 7.54233 0.5 18.7278 0.5C29.9134 0.5 40.5 4.55063 40.5 15.1835Z'
  };
  let currentTime = new Date;
  let cloutTotal =(window.innerWidth <= 768)?6:11;
  let currentHour = currentTime.getHours();
  let isAMorPM = (currentHour >= 5 && currentHour < 20)?'am':'pm';


  //let firstVname = topnameArray1[Math.floor(Math.random()*topnameArray1.length)];
  //let secondVname = topnameArray2[Math.floor(Math.random()*topnameArray2.length)];

  //let firstVImg = process.env.PUBLIC_URL + `../images/villagers/${firstVname}.png`
  //let secondVImg = process.env.PUBLIC_URL + `../images/villagers/${secondVname}.png`

  useEffect(() => {
      const intervalId = setInterval(() => {
          let firstVname = topnameArray1[Math.floor(Math.random()*topnameArray1.length)];
          let secondVname = topnameArray2[Math.floor(Math.random()*topnameArray2.length)];

          setCurrentFirstImage(process.env.PUBLIC_URL + `/images/villagers/${firstVname}.png`);
          setCurrentSecondImage(process.env.PUBLIC_URL + `/images/villagers/${secondVname}.png`);

      }, 6000)

      return () => clearInterval(intervalId);
  }, [])


  return (
  <header className={`App-header morning`}>
    <div className="cloud-container">
      {
        <svg  width="141" height="71" viewBox="0 0 141 71" xmlns="http://www.w3.org/2000/svg">
          <defs>
            { Object.keys(cloudtypeObj).map(c => {
               let type = cloudtypeObj[(c%3 + 1)],
                   path = cloudPathObj[(c%3 + 1)];
               return <path key={c} id={`cloud-${type}`} d={path} className={`cloud ${type}`}/>
            })}
          </defs>
        </svg>

      }
      {
        [...Array(cloutTotal).keys()].map(c => {
          let cloudtype = cloudtypeObj[(c%3 + 1)];
          let cloudW = 141, cloudH = 80, vS = 80;
          return (
            <svg className='clouds' key={c} width={cloudW} height={(cloudtype !== 'three')?cloudH :cloudW} viewBox={(cloudtype !== 'three')?`0 0 ${cloudW} ${cloudH}`:`0 0 ${cloudW} ${cloudW}`} xmlns="http://www.w3.org/2000/svg">
              {(cloudtype === 'three') && <image href={(c%4 !== 0)?currentFirstImage:currentSecondImage}  preserveAspectRatio="xMidYMid meet" height={vS} width={vS}></image>}
              <use href={`#cloud-${cloudtype}`} transform={`translate(0, ${(cloudtype !== 'three')?10 :cloudH/1.25})`}/>
            </svg>
          )
      })
      }
    </div>
    <p className="App-title">
      <span className="title-part">What makes a villager </span>
      <span className="title-part popular">POPULAR</span>
      in Animal Crossing?
      <span className="title-part game-tag">New Horizon</span>
    </p>
    <div className="App-title-authors">
      <p className="App-title-by">by</p>
      <div className="author-avatars">
        <AuthorAvatar name="Xindeling Pan" avatar="Ling"/>
        &
        <AuthorAvatar name="Jenny Peng" avatar="Jenny"/>
      </div>
    </div>
  </header>
  );
};

export default Header;
